import { Fragment, useState, useEffect } from 'react';
import RenderInfoLogic from '../../../../../Components/InfoSidebar/RenderInfoLogic.jsx';
import RenderSourcesLogic from '../source/RenderSourcesLogic';
import SharedButton from '../../../../../global/Button/Button';
import { getAvailableCharts } from '../../helpers/graphHelpers.ts';

function ManageGraphs({
  sectionTitle,
  tab,
  view,
  source,
  names, // todo: rename to searchItems
  searchItems,
  title, // todo: better title? ala sectionTitle
  Graph = null, // todo: not passed, refactor away
  setIsInfoSidebarOpen,
  setSearchItems,
}) {
  const [sourceOpen, setSourceOpen] = useState(false);
  const [chartsSelect, setChartsSelect] = useState(false);

  const handleDropdownClick = (item) => {
    setSelectedChart(item.toUpperCase())
    setChartsSelect(!chartsSelect)
  }

  let keySearch = '';

  if (searchItems.length > 0) {
    let prefix = '';
    if (title === 'DISEASES') {
      prefix = 'disease=';
      keySearch = `${prefix}${searchItems.map(item => `UMLS_${item.id}`).join(',')}`;
    } else if (title === 'GENES') {
      prefix = 'gene_ncbi_id=';
      keySearch = `${prefix}${searchItems.map(item => item.id).join(',')}`;
    } else if (title === 'VARIANTS') {
      prefix = 'variant=';
      keySearch = `${prefix}${searchItems.map(item => item.id).join(',')}`;
    }
  }

  const defaultChart =
    searchItems.length > 1 || (names.length === 1 && title === 'SummaryVDA' && title === 'GENES')
      ? 'HEATMAP'
      : 'LINE';
  const [selectedChart, setSelectedChart] = useState(defaultChart);

  // useEffect(() => {
  //   if (!(searchItems.length > 1 || (names.length === 1 && title === 'SummaryVDA' && title === 'GENES'))) {
  //     setSelectedChart('LINE');
  //   }
  // }, [searchItems]);

  useEffect(() => {
    if (searchItems.length > 1 || (names.length === 1 && title === 'SummaryVDA' && title === 'GENES')) {
      setSelectedChart('HEATMAP');
    } else {
      setSelectedChart('LINE');
    }
  }, [searchItems, names, title]);

  return (
    <Fragment>
      <div className="Cabtabla mt-3">
        {names && (
          <div className="row">
            <RenderInfoLogic
              searchItems={searchItems}
              setSearchItems={setSearchItems}
              setIsInfoSidebarOpen={setIsInfoSidebarOpen}
            />
            <div className="col-4 text-right">
              <div className=" justify-content-end">
                <SharedButton onClick={() => setSourceOpen(!sourceOpen)} arrow={sourceOpen ? 'up' : 'down'}>
                  Source: {source.replace('_', ' ')}
                </SharedButton>
              </div>
              <div className="grid mt-3 justify-items-end">
                <SharedButton
                  arrow={chartsSelect ? 'up' : 'down'}
                  onClick={() => setChartsSelect(!chartsSelect)}
                >
                  Select Graph: {selectedChart}
                </SharedButton>
                {/* Dropdown */}
                {chartsSelect && (
                  <div className="absolute z-10 mt-8 w-40 rounded-md shadow-lg bg-white border">
                    <ul className="py-1 text-sm text-gray-700">
                      {getAvailableCharts(names, sectionTitle, title).map((item, idx) => (
                        <li
                          key={idx}
                          className="px-4 py-2 hover:bg-blue cursor-pointer hover:text-white"
                          onClick={() => handleDropdownClick(item)}
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div>{sourceOpen && <RenderSourcesLogic tab={tab} />}</div>
          </div>
        )}
      </div>

      {Graph && (
        <Graph
          source={source}
          tab={tab}
          keySearch={keySearch}
          view={view}
          names={names}
          selectedChart={selectedChart}
          setSearchItems={setSearchItems}
        />
      )}
    </Fragment>
  );
}

export default ManageGraphs;
